export default "__VITE_ASSET__5ebFJb7n__"